module.exports = __webpack_public_path__ + "static/media/Burger_Builder.c15eba72.png";